<template>
  <div>
  <navbar :hasSearch="true"/>
    <div id="content">
      <!-- Row 1 Open -->
      <div class="row">
       <div class="col-md-6 pb-3">
         <div class="card h-100">
          <ol class="breadcrumb my-auto">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'landingPage' }"><a class="black-text" href="#">Home</a></router-link>
              <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
            </li>
            <li class="breadcrumb-item active font-weight-bold">
              <a class="black-text" href="#">Main Dashboard</a>
              <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
            </li>
          </ol>
         </div>
      </div>
        <quick-actions></quick-actions>
      </div>
      <!-- Row 1 Close -->

      <div class="dashboard_body">
        <!-- Row 2 Open -->
        <div class="row row-20">
          <customer></customer>
          <account-summary></account-summary>
          <!-- <unbilled-usage></unbilled-usage> -->
        </div>
        <!-- Row 2 Close -->

        <!-- Row 3 Open -->
        <div class="row row-20">
          <contracts></contracts>
          <finance></finance>
        </div>
        <!-- Row 3 Close -->

        <!-- Row 4 Open -->
        <div class="row row-20">
          <meter-info></meter-info>
        </div>
        <!-- Row 4 Close -->

      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import QuickActions from '@/components/QuickActions.vue';

import Customer from '@/components/widgets/Customer.vue';
import AccountSummary from '@/components/widgets/AccountSummary.vue';
import Contracts from '@/components/widgets/Contracts.vue';
import Finance from '@/components/widgets/Finance.vue';
import MeterInfo from '@/components/widgets/MeterInfo.vue';

export default {
  components: {
    Navbar,
    QuickActions,
    Customer,
    AccountSummary,
    Contracts,
    Finance,
    MeterInfo,
  },
  computed: {
    customerReference() {
      return window.location.pathname.split('/').reverse()[0];
    },
  },
  methods: {
    setCustomer() {
      this.$store.dispatch('setCustomer', this.customerReference);
      this.$router.push('/dashboard/' + this.customerReference);
    },
  },
  created() {
    this.setCustomer().catch(() => null);
  },

  mounted() {
    this.$store.dispatch('getMappings').catch(() => null);
  },
};
</script>
